(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["index-poc-order"] && !window.DesignMode) return;
  try {
    
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  if(getUrlParameter("lcid").length > 0 && getUrlParameter("scid").length > 0) {
    jQuery.get("https://pocorder.poweraware.com/api/"+getUrlParameter("lcid")+"/"+getUrlParameter("scid"),function(data) {
      $("input[name=email]").val(data['data']['email'] || '');
      if(data['data']['mergeTags']) {
       $("input[name=name]").val(data['data']['mergeTags']['FULL_NAME'] || '');
       $("input[name=company]").val(data['data']['mergeTags']['MERGE_COMPANY'] || '');
      }
    });
  }

  function getLanguage(email) {
	var nonCountryTLD = "com,net,org,edu,gov,mil,nu,io,eu,app".split(",");
	var iso = email.split(".").slice(-1)[0] || nonCountryTLD[0];
	if(nonCountryTLD.includes(iso)) {
		return window.location.pathname.split("/")[1] || "se";
	} else {
		return iso;
	}
  }

  function getSource() {
   	if(getUrlParameter("gclid").length > 0) {
		return "GoogleAds";
	}
	if(getUrlParameter("utm_source").length > 0) {
		return getUrlParameter("utm_source");
	}
	return ((Cookies.get("source") && Cookies.get("source").length > 0) ? Cookies.get("source") : "");
  }

  function setSource() {
	Cookies.set("source",getSource(),{expires: 7*365});
  }

  $(document).ready(function() {
	  //Lock source
	  setSource();

	  var is_product_company = getUrlParameter("pf") || false;
	  if(is_product_company) {
		$("#pf").hide();
	  }

      $("#order-btn").click(function() {
      var name = $("input[name=name]").val();
      var email = $("input[name=email]").val();
	  var country = getLanguage(email || ""); 
      var telephone = $("input[name=phone]").val();
      var company = $("input[name=company]").val();
	  var product_company = $("input[name=product_company]").val() || "";
      var apsis_id = getUrlParameter("cid") || "";
	  var source = getSource();
	  var category = "B2B";

	  console.log(country,source);

      var data = {apsis_id:"noll",source:source,category:category,email:email,country:country,name:name,telephone:telephone,company:company,product_company:product_company,created_at:new Date(),c:1};
      
      $(this).hide();
      $(".error").hide();
      $(".loader").show();
      
      $.ajax({
    	type: "POST",
        url: "https://pocorder.poweraware.com/order",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function(res){
          if(res.err) {
           $(".error").show();
           $(".loader").hide();
           $("#order-btn").show();
          }else{
			console.log("POC ORDER");

			//Linked in tracker
			console.log("LINKEDIN TRACK");
			(new Image()).src="https://px.ads.linkedin.com/collect/?pid=2370730&conversionId=2902588&fmt=gif";

    		ga('send', 'event', 'Signup Form', 'submit', {
        		hitCallback: function() { console.log("POC ORDERED EVENT"); } });

           $(".success").show();
           $(".poc-form").fadeOut(100);
          }
        }
      });
      
      return false;	
    });
    
  });

  } catch(e) { console.error(e); }
})();

})();
